// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__PavJT","title":"ClientCherryInfo_title__bVZk3","itemText":"ClientCherryInfo_itemText__3l2Hi"};